<script setup>
import {useReservationsStore, useRestaurantsStore, useUsersStore} from "@/stores"
import {storeToRefs} from "pinia"
import axios from "@axios"
import {
  requiredValidator
} from '@validators'
import {useRoute} from "vue-router"

const route = useRoute()
const router = useRouter()

const refVForm = ref()
const favoriteMarkets = ref([])

const usersStore = useUsersStore()
let myUser = null;
({ myUser } = storeToRefs(usersStore))

const restaurantsStore = useRestaurantsStore()
let restaurants = null
let markets = [];
({ restaurants, markets } = storeToRefs(restaurantsStore))
restaurantsStore.getRestaurants()

const reservationsStore = useReservationsStore()

const errors = ref({
  name: undefined,
  market: undefined,
})

const toggleFavorite = restaurant => {
  if(restaurant.unfavorited){
    restaurant.unfavorited = false
    restaurantsStore.favoriteRestaurant(restaurant._id, myUser.value._id)
  } else {
    restaurant.unfavorited = true
    restaurantsStore.unfavoriteRestaurant(restaurant._id, myUser.value._id)
  }

  //restaurantsStore.toggleFavorite(restaurant)
}

//computed property for favoriteRestaurants
const favoriteRestaurants = computed(() => {
  let filteredRestaurants = []
  let markets = new Set()
  filteredRestaurants = restaurants.value.filter(restaurant => {
    if(restaurant.isFavorited || restaurant.favoritedBy?.includes(myUser.value._id) || restaurant.hasOwnProperty('unfavorited')){
      markets.add(restaurant.market)
      
      return true
    }
    
    return false
  })
  markets = Array.from(markets)
  markets.sort()
  favoriteMarkets.value = Array.from(markets)
  
  return filteredRestaurants
})
</script>

<template>
  <div class="content-wrapper mt-6">
    <div>
      <VCard class="pa-10 pt-8">
        <h2 class="mb-4">
          Favorites
        </h2><p
          v-if="myUser?.isPlatinum"
          class="mt-4"
        >
          As a Platinum Member you can Request any restaurant, anywhere!<br><span class="text-caption">(RM will try to get request considered)</span>
        </p>

        <div
          v-if="favoriteRestaurants.lenght > 0"
          class="mt-4"
        >
          Add more favorites
        </div>
        <div class="mt-4">
          Add favorites now
        </div>
        <RestaurantFavoriter
          is-dialog-visible=""
          confirmation-msg=""
        />
        <div
          v-for="market in favoriteMarkets"
          class=""
        >
          <h3>{{ market }}</h3>
          <div
            v-for="restaurant in favoriteRestaurants"
            class="ml-4"
          >
            <div
              v-if="restaurant.market == market"
              class="hover-div cursor-pointer"
            >
              <VIcon
                size="20"
                class="ml-1 add-circle-icon"
                icon="mdi-add-circle-outline"
                color="primary"
                @click="usersStore.startNewReservation({ restaurant: restaurant.name, market: restaurant.market })"
              /> {{ restaurant.name }}
              <VTooltip :text="(!restaurant.unfavorited ? '3Remove Favorite' : 'Add to Favorites')">
                <template #activator="{ props }">
                  <VIcon
                    size="20"
                    class="ml-1 no-outline"
                    :icon="(restaurant.unfavorited ? 'mdi-heart-outline' : 'mdi-heart')"
                    :color="(restaurant.unfavorited ? '' : 'error')"
                    v-bind="props"
                    @click="toggleFavorite(restaurant)"
                  />
                </template>
              </VTooltip>
            </div>
          </div>
        </div>
      </VCard>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.no-outline {
    outline: none;
  }

  /* Initially hide the add-circle icon */
  .hover-div > .add-circle-icon {
    opacity: 0;
    transition: opacity 0.3s;  /* optional: for smooth transition */
  }

  /* Show the add-circle icon when the parent div is hovered */
  .hover-div:hover > .add-circle-icon {
    opacity: 1;
  }

  ol{
    margin-left: 2rem;
  }

  ol li{
    list-style-type: decimal;
  }

  ul {
    margin-left: 2em;
  }

  ul li{
    list-style-type: circle;
  }
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: AclDemo
  allowLoggedInOnly: true
</route>
